const initialState = {
    author: '',
    category: '',
    search: '',
};
export default initialState;
